import pathifyDefault, { get, sync, make, Payload } from 'vuex-pathify'

// options
pathifyDefault.options.mapping = 'simple'
pathifyDefault.options.deep = 2

// Re-export.
export default pathifyDefault
export { get, sync, make, Payload }
